import { hot } from 'react-hot-loader/root';
import Component from './assetsList-redux';

export default hot(Component);
